import _core from "./core.js";
import _component from "./component.js";
import _fragment from "./fragment.js";
import _helmet from "./components/helmet.js";
var exports = {};
var __rest = exports && exports.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStyles = void 0;
const core_js_1 = _core;
const component_js_1 = _component;
const fragment_js_1 = _fragment;
const helmet_js_1 = _helmet;
const withStyles = (...styles) => WrappedComponent => {
  return class extends component_js_1.Component {
    render() {
      const _a = this.props,
        {
          children
        } = _a,
        rest = __rest(_a, ["children"]);
      const helmets = [];
      styles.forEach(style => {
        var _a;
        if (typeof style === "string") {
          helmets.push((0, core_js_1.h)(helmet_js_1.Helmet, null, (0, core_js_1.h)("style", null, style)));
        } else if (typeof style === "function") {
          const _style = style();
          if (typeof _style === "string") {
            helmets.push((0, core_js_1.h)(helmet_js_1.Helmet, null, (0, core_js_1.h)("style", null, _style)));
          }
        } else if (typeof style === "object") {
          const _style = (_a = style.toString) === null || _a === void 0 ? void 0 : _a.call(style);
          if (typeof _style === "string") {
            helmets.push((0, core_js_1.h)(helmet_js_1.Helmet, null, (0, core_js_1.h)("style", null, _style)));
          }
        }
      });
      const component = children && children.length > 0 ? (0, core_js_1.h)(WrappedComponent, Object.assign({}, rest), children) : (0, core_js_1.h)(WrappedComponent, Object.assign({}, this.props));
      return (0, core_js_1.h)(fragment_js_1.Fragment, null, ...helmets, component);
    }
  };
};
exports.withStyles = withStyles;
//# sourceMappingURL=withStyles.js.map
export default exports;